export default "__VITE_ASSET__BwN$X_KB__"